module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sdk_iframe":"Встраиваемая страница (iframe)","sdk_page":"Независимая страница"},"en":{"sdk_iframe":"IFrame","sdk_page":"Page"}}')
  delete Component.options._Ctor
}
